module.exports = __webpack_public_path__ + "img/37073-051.bcc81867.jpg";